





















import click2Top from "@/common/directives/click2Top";
import { Vue, Component, Watch } from "vue-property-decorator";
import QNav from "./qNav.vue";
import QFooter from "./qFooter.vue";
import EditProfile from "@/sites/admin/pages/editProfile.vue";
import { namespace } from "vuex-class";
import store from "@/store";

const authStore = namespace("Auth");

@Component({
  name: "AdminLayout",
  directives: {
    click2Top,
  },
  components: {
    QFooter,
    QNav,
    EditProfile,
  },
})
export default class AdminLayout extends Vue {
  @authStore.Action
  fetchCurrentUser!: () => void;

  @authStore.Getter
  public getRole!: string;

  @authStore.Getter
  public getLoggingUser!: any;

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(newValue: any, oldValue: any) {
    if (newValue && oldValue && newValue.name !== oldValue.name) {
      this.fetchCurrentUser();
      this.changedRoute++;
    }
    // this.checkRole();
  }

  mounted() {
    // this.checkRole();
    if (!this.getLoggingUser) {
      store.dispatch("Auth/logout");
    }
    console.log("admin layout");
    // fetch current user
    this.fetchCurrentUser();
    if (this.$router.currentRoute.name === "admin") {
      this.redirect();
    }
  }

  public changedRoute = 1;

  get titlePage(): string {
    return this.$route.meta.title || "";
  }
  get subTitle(): string {
    return this.$route.meta.subTitle || "";
  }

  public closeNavigate() {
    (this.$refs.top as Element).classList.remove("open");
  }

  get classPage(): string[] {
    this.changedRoute; // hack to re-computed
    const initalClass = ["mb__admin"];
    if (this.$router.currentRoute.meta.className) {
      initalClass.push(this.$router.currentRoute.meta.className);
    }
    return initalClass;
  }

  public editProfile() {
    (this.$refs.editProfile as EditProfile).show();
  }

  redirect() {
    if (this.getLoggingUser && this.getLoggingUser.role === "group") {
      return this.$router.push({ name: "admin.info" });
    } else if (this.getLoggingUser && this.getLoggingUser.role === "admin") {
      return this.$router.push({ name: "admin.user" });
    } else {
      return this.$router.push({ name: "login" });
    }
  }
}
